const UpdateUri = data => {
  if (!data) return ""
  const textReplace = "/pionero2023"
  const newText = data.replace(textReplace, "")
  return newText
}
export default UpdateUri
